export type BulkReportLimitGroup = {
  id?: unknown;
  reportCount?: unknown;
  savedResponseCount?: unknown;
};

const toPositiveInteger = (value: unknown): number | undefined => {
  if (value == null) {
    return undefined;
  }
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric <= 0) {
    return undefined;
  }
  return Math.floor(numeric);
};

export const resolveBulkGroupReportCount = (group: BulkReportLimitGroup | null | undefined): number => {
  const reportCount = toPositiveInteger(group?.reportCount);
  if (reportCount !== undefined) {
    return reportCount;
  }
  return toPositiveInteger(group?.savedResponseCount) ?? 0;
};

export const resolveBulkReportCountLimit = (
  taskQuantity: unknown,
  groups: BulkReportLimitGroup[] = [],
  activeBulkGroupId?: unknown,
): number | undefined => {
  const quantity = toPositiveInteger(taskQuantity);
  if (quantity === undefined) {
    return undefined;
  }
  const activeGroupId = toPositiveInteger(activeBulkGroupId);
  const usedByOtherGroups = groups.reduce((total, group) => {
    const groupId = toPositiveInteger(group?.id);
    if (activeGroupId !== undefined && groupId === activeGroupId) {
      return total;
    }
    return total + resolveBulkGroupReportCount(group);
  }, 0);
  return Math.max(quantity - usedByOtherGroups, 0);
};
